import * as types from '../types'

export default {
    state: {
       course_resources:null,
       course_exam:null,
       course_exam_temp:null,
       cache_type:0,
       student_save_data:[],
       student_save_status: 0,
       student_jude_exam_type:0,
       class_trigger_id:0,
       exam_header_choose:0,
       exam_card_change_status:null
    },
    mutations: {
        [types.COURSERESOURCES]: (state, data) => {
            state.course_resources = data;
            console.log(data);
        },
        [types.COURSEEXAM]: (state, data) => {
            state.course_exam = data;
            console.log(data);
        },
        [types.COURSEEXAMTEMP]: (state, data) => {
            state.course_exam_temp = data;
            console.log(data);
        },
        [types.CACHETYPE]: (state, data) => {
            state.cache_type = data;
            console.log(data);
        },
        [types.STUDENTSAVEDATA]: (state, data) => {
            console.log(state.student_save_data);
            state.student_save_data.push(data);
            console.log(state.student_save_data);
        },
        [types.STUDENTSAVESTATUS]: (state, data) => {
            state.student_save_status = data;
            console.log(data);
        },
        [types.STUDENTJUDEEXAMTYPE]: (state, data) => {
            state.student_jude_exam_type = data;
            console.log(data);
        },
        [types.CLASSTRIGGERID]: (state, data) => {
            state.class_trigger_id = data;
            console.log(data);
        },
        [types.EXAMHEADERCHOOSE]: (state, data) => {
            state.exam_header_choose = data;
            console.log(data);
        },
        [types.TRAGGEREXAMCARD]: (state, data) => {
            state.exam_card_change_status = data;
            console.log(data);
        },
    },
    getters: {
    },
    actions: {
    }
}